const ShoppableImage = () => {
  const activeClass = 'shoppable-image__hotspot--active';
  const tooltipDelay = 300;

  const selectors = {
    container: '[data-shoppable-image-container]',
    wrapper: '[data-shoppable-image-wrapper]',
    image: '[data-shoppable-image-img]',
    hotspot: '[data-hotspot]',
    tooltipWrapper: '[data-tooltip-wrapper]'
  };

  function init(sectionId) {
    const containers = [...document.querySelectorAll(selectors.container)].filter(
      (container) => !sectionId || container.closest(`#shopify-section-${sectionId}`)
    );

    containers.forEach(setupContainer);
  }

  function setupContainer(container) {
    const wrapper = container.querySelector(selectors.wrapper);
    const image = container.querySelector(selectors.image);
    const hotspots = [...container.querySelectorAll(selectors.hotspot)];

    if (!wrapper || !hotspots.length) {
      return;
    }

    const positionAll = () => {
      positionHotspots(wrapper, hotspots);
      positionTooltips(wrapper, hotspots);
    };

    positionAll();

    if (image && !image.complete) {
      image.addEventListener('load', positionAll, { once: true });
    }

    window.addEventListener('resize', window.themeCore.utils.debounce(positionAll, 150));

    hotspots.forEach((hotspot) => {
      setupHotspot(hotspot, hotspots, () => positionTooltips(wrapper, hotspots));
    });

    document.addEventListener('click', (event) => {
      if (!container.contains(event.target)) {
        deactivateAll(hotspots);
      }
    });
  }

  function setupHotspot(hotspot, allHotspots, repositionTooltips) {
    const tooltipWrapper = hotspot.querySelector(selectors.tooltipWrapper);
    let hoverTimer = null;

    const activate = () => {
      clearTimeout(hoverTimer);
      if (hotspot.classList.contains(activeClass)) {
        return;
      }
      deactivateAll(allHotspots);
      repositionTooltips();
      hotspot.classList.add(activeClass);
    };

    const scheduleDeactivate = () => {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => hotspot.classList.remove(activeClass), tooltipDelay);
    };

    hotspot.addEventListener('mouseenter', activate);
    hotspot.addEventListener('mouseleave', scheduleDeactivate);
    hotspot.addEventListener('focus', activate);

    hotspot.addEventListener('click', (event) => {
      event.stopPropagation();

      if (hotspot.classList.contains(activeClass)) {
        return;
      }

      event.preventDefault();
      activate();
    });

    if (tooltipWrapper) {
      tooltipWrapper.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
      tooltipWrapper.addEventListener('mouseleave', scheduleDeactivate);
    }
  }

  function deactivateAll(hotspots) {
    hotspots.forEach((hotspot) => hotspot.classList.remove(activeClass));
  }

  function positionHotspots(wrapper, hotspots) {
    const wrapperBounds = wrapper.getBoundingClientRect();

    hotspots.forEach((hotspot) => {
      const ySetting = parseInt(hotspot.dataset.hotspotYAxis, 10);
      const xSetting = parseInt(hotspot.dataset.hotspotXAxis, 10);
      const hotspotBounds = hotspot.getBoundingClientRect();

      const yDifference = wrapperBounds.height - hotspotBounds.height;
      const yPercentage = (yDifference / wrapperBounds.height) * ySetting;
      hotspot.style.bottom = `${yPercentage}%`;

      const xDifference = wrapperBounds.width - hotspotBounds.width;
      const xPercentage = (xDifference / wrapperBounds.width) * xSetting;
      hotspot.style.left = `${xPercentage}%`;

      hotspot.style.visibility = 'visible';
    });
  }

  function positionTooltips(wrapper, hotspots) {
    const wrapperBounds = wrapper.getBoundingClientRect();

    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(selectors.tooltipWrapper);

      if (!tooltip) {
        return;
      }

      tooltip.style.left = '';
      tooltip.style.top = '';

      const tooltipBounds = tooltip.getBoundingClientRect();

      if (tooltipBounds.right >= wrapperBounds.right) {
        tooltip.style.left = `${wrapperBounds.right - tooltipBounds.right}px`;
      } else if (tooltipBounds.left <= 0) {
        tooltip.style.left = `${Math.abs(tooltipBounds.left)}px`;
      }

      if (tooltipBounds.bottom >= window.innerHeight) {
        tooltip.style.top = `${window.innerHeight - tooltipBounds.bottom}px`;
      }
    });
  }

  return Object.freeze({
    init
  });
};

const action = () => {
  window.themeCore.ShoppableImage = window.themeCore.ShoppableImage || ShoppableImage();
  window.themeCore.utils.register(window.themeCore.ShoppableImage, 'shoppable-image');
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener('theme:all:loaded', action, { once: true });
}